var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('add-wash-button',{attrs:{"item":_vm.item,"apvs":_vm.apvs,"usersModel":_vm.usersModel},on:{"itemAdded":function($event){return _vm.itemAdded()}}}),_c('show-wash-records-button',{attrs:{"washObject":_vm.washObject}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }